import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import ViewDevice from '../views/ViewDevice.vue'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'ViewDevice',
    component: ViewDevice
  }
]

const router = new VueRouter({
  routes
})

export default router
